import { StoreSettings } from '../types';

const SETTINGS_STORAGE_KEY = 'noor_pieces_store_settings_v1';
const SETTINGS_EVENT_NAME = 'noor_settings_updated';

const defaultSettings: StoreSettings = {
  storeName: 'Noor Pieces',
  supportEmail: 'atelier@noorpieces.com',
  currency: 'INR (₹)',
  autoSaveInterval: '4 seconds',
  freeShippingThreshold: 150,
  taxRate: 0.08,
  enableReviews: true,
  enableWishlist: true,
  enableCoupons: true,
  enableGiftCards: true,
};

export class SettingsService {
  private settings: StoreSettings;

  constructor() {
    this.settings = this.loadFromStorage();
  }

  private loadFromStorage(): StoreSettings {
    if (typeof window === 'undefined') return defaultSettings;
    try {
      const stored = localStorage.getItem(SETTINGS_STORAGE_KEY);
      if (stored) {
        return { ...defaultSettings, ...JSON.parse(stored) };
      }
    } catch (e) {
      console.warn('Failed to load store settings:', e);
    }
    return defaultSettings;
  }

  public getSettings(): StoreSettings {
    return { ...this.settings };
  }

  public updateSettings(newSettings: Partial<StoreSettings>): StoreSettings {
    this.settings = { ...this.settings, ...newSettings };
    if (typeof window !== 'undefined') {
      try {
        localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(this.settings));
        window.dispatchEvent(new CustomEvent(SETTINGS_EVENT_NAME));
      } catch (e) {
        console.error('Failed to save store settings:', e);
      }
    }
    return { ...this.settings };
  }

  public subscribe(listener: () => void): () => void {
    if (typeof window === 'undefined') return () => {};
    const handler = () => listener();
    window.addEventListener(SETTINGS_EVENT_NAME, handler);
    return () => window.removeEventListener(SETTINGS_EVENT_NAME, handler);
  }
}

export const settingsService = new SettingsService();
